export enum QuickTagEnum {
    AlwaysOnService = 1,
    Gmp = 2,
    Fda = 3,
    Iso = 4,
}

// Etykiety do wyświetlania (odpowiedniki Display(Name = "..."))
export const QUICK_TAG_LABEL: Record<QuickTagEnum, string> = {
    [QuickTagEnum.AlwaysOnService]: "24/7",
    [QuickTagEnum.Gmp]: "GMP",
    [QuickTagEnum.Fda]: "FDA",
    [QuickTagEnum.Iso]: "ISO",
};

export const QUICK_TAG_MAP: Record<QuickTagEnum, { value: QuickTagEnum; label: string }> = 
    (Object.values(QuickTagEnum) as Array<string | number>)
        .filter((v): v is number => typeof v === "number")
        .reduce((acc, value) => {
            acc[value] = { value, label: QUICK_TAG_LABEL[value] };
            return acc;
        }, {} as Record<QuickTagEnum, { value: QuickTagEnum; label: string }>);

// Opcje do komponentów (np. MUI <Select/> lub MultiSelect)
export const QUICK_TAG_OPTIONS = Object.entries(QuickTagEnum)
    .filter(([k, v]) => typeof v === "number") // tylko wartości liczbowe
    .map(([name, value]) => ({
        id: value as unknown as QuickTagEnum,
        label: QUICK_TAG_LABEL[value as unknown as QuickTagEnum] ?? name,
    }))
    // usuwamy duplikaty po id (zachowaj pierwszy)
    .filter((opt, idx, arr) => arr.findIndex(o => o.id === opt.id) === idx);